import buildGraphQLProvider from "ra-data-graphql-simple";

const getToken = () => localStorage.getItem("token");

const baseDataProvider = () =>
  buildGraphQLProvider({
    clientOptions: {
      uri: "/api/merchant/graphql",
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    },
  });

const getFileBase64 = (file, callback) => {
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onload = () => resolve(callback(reader.result));

    reader.onerror = () => {
      reject("Fail");
    };
    reader.readAsDataURL(file);
  });
};

const dataProvider = () => ({
  getList: (resource, params) =>
    baseDataProvider().then(async (dp) => {
      const { filter, pagination } = params;
      const { page, perPage } = pagination;

      const response = await dp.getList(resource, params);

      if (filter.has_changes === true) {
        const hasChangeClients = await dp.getList(resource, {
          ...params,
          pagination: {
            page: 1,
            perPage: response.total,
          },
        });

        const filteredData = hasChangeClients.data.filter(
          (client) =>
            client.unconfirmed_changes && client.unconfirmed_changes.length > 0
        );

        const paginatedData = filteredData.slice(
          (page - 1) * perPage,
          page * perPage
        );

        return {
          data: paginatedData,
          total: filteredData.length,
        };
      }

      return response;
    }),
  getOne: (resource, params) => {
    if (resource === "Coordinate") {
      return baseDataProvider().then((dp) => dp.getList(resource, params));
    }
    return baseDataProvider().then((dp) => dp.getOne(resource, params));
  },
  getMany: (resource, params) =>
    baseDataProvider().then((dp) => dp.getMany(resource, params)),
  getManyReference: (resource, params) =>
    baseDataProvider().then((dp) => dp.getManyReference(resource, params)),
  create: (resource, params) => {
    if (params.data.attachments) {
      return getFileBase64(params.data.attachments.rawFile, (result) => {
        params.data.data = result;
        delete params.data["attachments"];

        return baseDataProvider().then((dp) => dp.create(resource, params));
      });
    }

    if (resource === "Coordinate") {
      const { data } = params;

      const fuelKeys = [
        "lpg",
        "diesel",
        "dieselPlus",
        "petrol92",
        "petrol95e",
        "petrol95",
        "petrol95Plus",
        "petrol98",
        "petrol100",
      ];

      const fuel_types = fuelKeys.filter((key) => data[key] === "+");

      const coordinateData = {
        name: data.name,
        address: data.address,
        lat: data.latitude,
        long: data.longitude,
        fuel_types,
        gas_brand_merchant_id: localStorage.getItem("gas_brand_merchant_id"),
      };

      return baseDataProvider().then((dp) =>
        dp.create(resource, { data: coordinateData })
      );
    }

    if (resource === "csvImport") {
      return baseDataProvider
        .mutate({
          mutation: "createCoupon",
          variables: { data: params.data },
        })
        .then((response) => ({ data: response.data.createCoupon }));
    }

    return baseDataProvider().then((dp) => dp.create(resource, params));
  },
  update: (resource, params) =>
    baseDataProvider().then((dp) => dp.update(resource, params)),
  updateMany: (resource, params) =>
    baseDataProvider().then((dp) => {
      return dp.updateMany(resource, params);
    }),
  delete: (resource, params) =>
    baseDataProvider().then((dp) => dp.delete(resource, params)),
  deleteMany: (resource, params) =>
    baseDataProvider().then((dp) => dp.deleteMany(resource, params)),
});

export default dataProvider;
